import { Classification } from "./classification";
const $ = window.$;

export class AIClassification {
  constructor(accuracyScore, hsCode, commodity, question, parent) {
    this.accuracyScore = accuracyScore;
    this.hsCode = hsCode;
    this.commodity = commodity;
    /**@type {Question} */
    this.question = question;
    /**@type {Classification} */
    this.parent = parent;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new AIClassification(
        input.accuracy_score,
        input.classified_hs_code,
        Classification.fromApiArray(input.commodity),
        Question.fromApiObject(input.question),
        Classification.fromApiObject(input.parent),
      )
    }
    return new AIClassification();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => AIClassification.fromApiObject(item));
    }
    if (input && typeof (input) === "object") {
      return [AIClassification.fromApiObject(input)];
    }
    return [];
  }
}

export class Question {
  constructor(answer, name) {
    /** @type {[Answer]} */
    this.answer = answer;
    this.name = name;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Question(
        Answer.fromApiArray(input.answers),
        input.name,
      )
    }
    return new Question();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Question.fromApiObject(item));
    }
    if (input && typeof (input) === "object") {
      return [Question.fromApiObject(input)];
    }
    return [];
  }
}

export class Answer {
  constructor(hsCode, name) {
    this.hsCode = hsCode;
    this.name = name;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Answer(
        input.hs_code,
        input.name,
      )
    }
    return new Answer();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Answer.fromApiObject(item));
    }
    if (input && typeof (input) === "object") {
      return [Answer.fromApiObject(input)];
    }
    return [];
  }

  render(parent) {
    $(parent).append($(`
      <div class="item-answer">
        <label class="radio" code="${this.name}">
          <input value="${this.hsCode}" type="radio" name="question_answer">
          <span class="checkmark"></span>
          <span class="name">${this.name}</span>
        </label>
      </div>
    `));
  }
}